import { render, staticRenderFns } from "./arrowIcon.vue?vue&type=template&id=9a9fafc6&"
var script = {}
import style0 from "./arrowIcon.vue?vue&type=style&index=0&id=9a9fafc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports